import { Instance } from 'mobx-state-tree';
import { SkippedCustomerDtoModelBase } from './SkippedCustomerDtoModel.base';

/* The TypeScript type of an instance of SkippedCustomerDtoModel */
export interface SkippedCustomerDtoModelType extends Instance<typeof SkippedCustomerDtoModel.Type> {}

/* A graphql query fragment builders for SkippedCustomerDtoModel */
export { selectFromSkippedCustomerDto, skippedCustomerDtoModelPrimitives, SkippedCustomerDtoModelSelector } from './SkippedCustomerDtoModel.base';

/**
 * SkippedCustomerDtoModel
 */
export const SkippedCustomerDtoModel = SkippedCustomerDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
